var app = angular.module("leonardo");

var SubgroupEditDialog = function($scope, $rootScope, FieldSubgroupService, FieldGroupService, SectorRestService,
                                  NotificationService, FormErrorsService) {
  $scope.isEdit = !isNull($scope.ngDialogData.subgroup);
  $scope.subgroup = angular.copy($scope.ngDialogData.subgroup);
  $scope.sectorRestService = SectorRestService;

  if ($scope.subgroup) {
    $scope.subgroup.group = $scope.subgroup.group || {id: 0};
    var sectors = [];
    angular.forEach($scope.subgroup.sectors, function(sector) {
      sectors.push(!isNull(sector.id) ? sector.id : sector);
    });
    $scope.subgroup.sectors = sectors;
  }
  if (!$scope.subgroup) {
    $scope.subgroup = {
     sectors:[]
    };
  }

  $scope.conditionOptions = FieldSubgroupService.CONDITIONS_TYPES;
  $scope.widgetOptions = FieldSubgroupService.WIDGET_TYPES;

  if (FieldGroupService.getCollection().length > 0) {
    $scope.groups = angular.copy(FieldGroupService.getCollection());
    $scope.groups.push({id: 0, name: 'Other'});
  }
  else {
    FieldGroupService.getAll({essential: true}).then(function(data) {
      $scope.groups = data;
      $scope.groups.push({id: 0, name: 'Other'});
    });
  }

  $scope.submit = function() {
    $scope.Form.$setSubmitted();

    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }

    var data = $scope.getData();

    if ($scope.isEdit) {
      $scope.subgroup.patch(data, true).then(function () {
        $rootScope.$broadcast('subgroup:changed');
        $scope.closeThisDialog();
      });
    }
    else {
      data.key = data.name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");
      FieldSubgroupService.post(data, true).then(function (result) {
        FieldSubgroupService.updateCollection(result);
        $rootScope.$broadcast('subgroup:changed');
        $scope.closeThisDialog();
      });
    }
  };


  $scope.getData = function() {
    var data = {
      name: $scope.subgroup.name,
      weight: $scope.subgroup.weight,
      db_condition: $scope.subgroup.db_condition,
      label_hidden: $scope.subgroup.label_hidden,
      data: $scope.subgroup.data ? $scope.subgroup.data : {},
      group: $scope.subgroup.group.id,
      sectors: $scope.subgroup.sectors
    };
    if (data.group == 0) delete data.group;
    return data;
  };
};

app.controller('SubgroupEditDialog', ['$scope', '$rootScope', 'FieldSubgroupService', 'FieldGroupService',
  'SectorRestService', 'NotificationService', 'FormErrorsService', SubgroupEditDialog]);
